import { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import MediaService from '../../services/MediaService';
import { completeRedo } from '../../services/RedoService';
import RedoRecorder from './RedoRecorder';
import loading from '../../loading-gif-png-5.gif';
import './RedoPage.scss';

const RedoPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const { pendingRedos } = useSelector((state) => state.redoReducer, shallowEqual);

  const [initialCount] = useState(pendingRedos.length);

  const [completing, setCompleting] = useState(false);

  const background = MediaService.getImage(
    '/Module1Images/U1M1_Background_Landscape.png',
    login
  );

  const currentRedo = pendingRedos[0];

  useEffect(() => {
    if (pendingRedos.length === 0) {
      navigate('/unitPage');
    }
  }, [pendingRedos.length, navigate]);

  const handleRedoComplete = async () => {
    setCompleting(true);
    const completedKey = currentRedo.media_key;
    const success = await completeRedo(login.endPoint, currentRedo.id);

    if (success) {
      dispatch({ type: 'REMOVE_PENDING_REDO', payload: completedKey });
    }

    const remaining = pendingRedos.length - 1;
    if (remaining > 0) {
      setCompleting(false);
      return;
    }
    navigate('/unitPage');
  };

  if (!currentRedo?.media_key) {
    return null;
  }

  if (completing) {
    return (
      <div
        id='recordpage'
        style={{ backgroundImage: `url(${background})` }}
      >
        <img id='loading' alt='loading' src={loading} />
      </div>
    );
  }

  return (
    <div className='redo-page'>
      {initialCount > 1 && (
        <div className='redo-progress'>
          {initialCount - pendingRedos.length + 1} of {initialCount}
        </div>
      )}
      <RedoRecorder
        key={currentRedo.media_key}
        redo={currentRedo}
        background={background}
        onComplete={handleRedoComplete}
      />
    </div>
  );
};

export default RedoPage;
